<template>
  <b-button-group size="sm" class="display-mode-toggle">
    <b-button
      :variant="value === 'absolute' ? 'primary' : 'outline-primary'"
      :aria-pressed="value === 'absolute' ? 'true' : 'false'"
      @click="setMode('absolute')"
    >
      <i class="fa fa-hashtag mr-1" />Números
    </b-button>
    <b-button
      :variant="value === 'percent' ? 'primary' : 'outline-primary'"
      :aria-pressed="value === 'percent' ? 'true' : 'false'"
      @click="setMode('percent')"
    >
      <i class="fa fa-percent mr-1" />%
    </b-button>
  </b-button-group>
</template>

<script>
export default {
  name: "DisplayModeToggle",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "absolute",
      validator: (v) => ["absolute", "percent"].includes(v),
    },
    storageKey: {
      type: String,
      default: null,
    },
  },
  mounted() {
    if (this.storageKey) {
      const stored = localStorage.getItem(this.storageKey);
      if (
        stored &&
        stored !== this.value &&
        ["absolute", "percent"].includes(stored)
      ) {
        this.$emit("input", stored);
      }
    }
  },
  methods: {
    setMode(mode) {
      if (mode === this.value) return;
      this.$emit("input", mode);
      if (this.storageKey) {
        localStorage.setItem(this.storageKey, mode);
      }
    },
  },
};
</script>

<style scoped>
.display-mode-toggle {
  display: inline-flex;
}
.display-mode-toggle .btn {
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0.35rem 0.75rem;
}
</style>
